// JsFromRoutes CacheKey 6aa10b775b2d8069902ca8ee96839593
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:account_id/settings'),
  previewHelpRedirects: /* #__PURE__ */ definePathHelper('post', '/:account_id/settings'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/settings'),
  updateWidget: /* #__PURE__ */ definePathHelper('patch', '/:account_id/settings/widget'),
  createChannel: /* #__PURE__ */ definePathHelper('post', '/:account_id/settings/channels'),
  updateChannel: /* #__PURE__ */ definePathHelper('patch', '/:account_id/settings/channels/:id'),
  destroyChannel: /* #__PURE__ */ definePathHelper('delete', '/:account_id/settings/channels/:id'),
  updateCsat: /* #__PURE__ */ definePathHelper('patch', '/:account_id/settings/csat'),
  regenerateToken: /* #__PURE__ */ definePathHelper('post', '/:account_id/settings/widget/regenerate-token'),
  sendToDeveloper: /* #__PURE__ */ definePathHelper('post', '/:account_id/settings/widget/send-to-developer'),
  createEmailDomain: /* #__PURE__ */ definePathHelper('post', '/:account_id/settings/email-domain'),
  destroyEmailDomain: /* #__PURE__ */ definePathHelper('delete', '/:account_id/settings/email-domain'),
  checkEmailDomain: /* #__PURE__ */ definePathHelper('post', '/:account_id/settings/email-domain/check'),
  sendTestEmail: /* #__PURE__ */ definePathHelper('post', '/:account_id/settings/email/send-test'),
  updateEmailBranding: /* #__PURE__ */ definePathHelper('patch', '/:account_id/settings/email-branding'),
}
